module.exports = __webpack_public_path__ + "img/teile.0d44fc1f.png";